import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const pricingList = createAsyncThunk('pricing/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `product_pricing`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'product_id': data?.product_id,
                'category_id': data?.category_id,
                'effective_date': data?.effective_date,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const pricingConfigurationSearch = createAsyncThunk('pricing/configuration', async ({ values, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'pricing_configuration',
            params: {
                'category_id': values?.category_id,
                'effective_date': values?.effective_date ? moment(values?.effective_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const savePricingConfiguration = createAsyncThunk('pricing/configuration/save', async ({ values }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'product_pricing',
            data: values,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const pricing = createSlice({
    name: 'pricing',
    initialState: {
        list: [],
        configuration: [],
        loading: false,
    },
    reducers: {
        clearPricingConfiguration: (state) => {
            state.configuration = []
        },
    },
    extraReducers: (builder) => {
        builder.addCase(pricingList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(pricingConfigurationSearch.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.configuration = action.payload.data.data || [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.configuration = []
            }
        });
    }
})

export const { clearPricingConfiguration } = pricing.actions
export default pricing.reducer;